// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"44":"5746a783","71":"9e0caf8c","184":"047c44e4","246":"bfa38125","354":"99e1f025","515":"d779666d","522":"4251866f","576":"2b7bfe55","674":"0061e8c3","697":"f9095786","979":"102e81a9"}[chunkId] + ".chunk.js";
};